import React from 'react';

import { pages, } from 'styles';

const SummaryOrderAcceptanceDetailsList: React.FC = ({ children, }) => {
    const { container, } = pages.checkout.makeSummaryDetailsList();

    return (
        <ul className={container}>
            {children}
        </ul>
    );
};

export default SummaryOrderAcceptanceDetailsList;
